import * as React from 'react';
import * as partners from './ourPartners.module.scss';
import dataPartners from "./data.json";
export const OurPartners = ({ data=dataPartners, sectionName, ttlClassName }) => {
  return (
    <section className={sectionName || partners.partners} id="partners">
      <div className="container">
        <h3 className={ttlClassName || partners.partners__title}>Наши партнёры</h3>
        <div className={partners.partners__block}>
          {
            data.map((elem, index) => (
              <a href={elem.link && elem.link} className={partners.partners__item} key={index} target={"_blank"} rel={"nofollow, noreferrer"}>
                <div className={partners.partner__imgWrapper}>
                  <img
                    src={elem.imgSrc}
                    alt={elem.name}
                  />
                </div>
                <p className={partners.partner__name}>{elem.name}</p>
              </a>
            ))
          }
        </div>
      </div>
    </section>
  );
};
